import React, { Component } from "react"
import { withRouter } from "react-router-dom"
import AddProductComponent from "../components/AddProductComponent"
import { withTranslation } from "react-i18next"

@withTranslation()
@withRouter
class AddProductPage extends Component {
  state = {}
  render() {
    const { t } = this.props
    return (
      <>
        <AddProductComponent />
      </>
    )
  }
}

export default withRouter(AddProductPage)
